export default __webpack_public_path__ + "static/media/a1.956d19fb.svg";